import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";

import event1 from "../../assets/img/broucher1.avif";
import event2 from "../../assets/img/broucher2.avif";
import event3 from "../../assets/img/broucher3.avif";
import event4 from "../../assets/img/broucher4.avif";

import footer from "../../assets/img/footer-bg.png";
import { RiDownloadCloudFill } from "react-icons/ri";

const brochuresData = [
  {
    title: "GGAS Maintenance Stairs",
    img: event1,
  },
  {
    title: "GGAS Service Carts",
    img: event2,
  },
  {
    title: "Aviation Tools",
    img: event3,
  },
  {
    title: "Tool Control Solutions",
    img: event4,
  },
];

const Brochures = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Brochures | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title="Brochures" t={t} />
      <section className="broucherSec sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h6>GGAS</h6>
            <h3>Download product brochures</h3>
          </div>
          <div className="brochuresCard">
            <div className="row">
              {brochuresData.map((item) => {
                return (
                  <div className="col-lg-6 col-md-6 col-sm-12 key={item}">
                    <div
                      className="brochuresItems"
                      style={{
                        backgroundImage: `url(${footer})`,
                        backgroundSize: "cover",
                      }}
                    >
                      <div className="eventFigure">
                        <img
                          src={item.img}
                          alt={item.title}
                          className="img-fluid"
                        />
                      </div>
                      <div className="eventContent">
                        <h4>
                          {item.title}{" "}
                          <span className="inline-block ms-2 text-white">
                            <RiDownloadCloudFill />
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Brochures;
